import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash.isnil';
import './Toolbar.scss';
import ToolbarInput from './input/ToolbarInput';
import Corrections from './corrections/Corrections';
import useClickOutside from '../../hooks/OutsideClicker';
import EndTimeModal from '../../features/probeDetails/reading/tro/readingRecord/modals/endTimeModal/EndTimeModal';
import { TOOLBAR_TYPES } from '../../constants/shared/ToolbarConstants';

const { END_TIME_TOOLBAR } = TOOLBAR_TYPES;

const Toolbar = ({
    toolbarTypeClassName,
    activeWordPosition,
    closeToolbar,
    toolbarPosition,
    onEscHandler,
    corrections,
    toolbarType,
    audioDuration,
    setEndWordData,
    setWordEvent,
}) => {
    const outsideClickRef = useRef(null);
    const [inputType, setInputType] = useState(null);

    const { position, toolbar, trianglePosition, isTopTriangle } = toolbarPosition;

    useClickOutside(outsideClickRef, closeToolbar);

    const TOOLBAR_CONTENT = {
        RESCORING_TOOLBAR: !isNil(inputType) ? (
            <ToolbarInput
                wordPosition={activeWordPosition}
                inputType={inputType}
                setWordEvent={setWordEvent}
            />
        ) : (
            <Corrections
                wordPosition={activeWordPosition}
                corrections={corrections}
                setInputType={setInputType}
                setWordEvent={setWordEvent}
            />
        ),
        [END_TIME_TOOLBAR]: (
            <EndTimeModal
                isShown={toolbarType === END_TIME_TOOLBAR}
                wordPosition={activeWordPosition}
                audioDuration={audioDuration}
                setEndWordData={setEndWordData}
            />
        ),
    };

    return (
        <section
            ref={outsideClickRef}
            className={`toolbar-section ${toolbarTypeClassName}`}
            style={position}
        >
            {isTopTriangle && <div className="triangle" style={trianglePosition} />}
            <div
                tabIndex="0"
                role="button"
                className={`toolbar ${toolbarTypeClassName}`}
                style={toolbar}
                onKeyDown={onEscHandler}
            >
                {toolbarType === END_TIME_TOOLBAR
                    ? TOOLBAR_CONTENT.END_TIME_TOOLBAR
                    : TOOLBAR_CONTENT.RESCORING_TOOLBAR}
            </div>
            {!isTopTriangle && <div className="triangle" style={trianglePosition} />}
        </section>
    );
};

Toolbar.defaultProps = {
    activeWordPosition: null,
    toolbarTypeClassName: '',
    toolbarPosition: {},
    corrections: [],
    closeToolbar: () => {},
    onEscHandler: () => {},
    toolbarType: null,
    audioDuration: null,
    setEndWordData: () => {},
    setWordEvent: () => {},
};

Toolbar.propTypes = {
    toolbarPosition: PropTypes.object,
    toolbarTypeClassName: PropTypes.string,
    corrections: PropTypes.array,
    activeWordPosition: PropTypes.number,
    closeToolbar: PropTypes.func,
    onEscHandler: PropTypes.func,
    toolbarType: PropTypes.string,
    audioDuration: PropTypes.number,
    setEndWordData: PropTypes.func,
    setWordEvent: PropTypes.func,
};

export default Toolbar;
